import {
	GetDocumentTreeType,
	DeleteDocumentTreeFileType,
	DownloadDocumentType,
	GetDocsFolderDetailsType,
	UpdateDocumentType,
} from "./types";

export const getDocumentTreeSlr = (state: any): GetDocumentTreeType =>
	state.fundDetails.documents.fileManager.getDocumentTree;
export const deleteDocumentTreeFileSlr = (state: any): DeleteDocumentTreeFileType =>
	state.fundDetails.documents.fileManager.deleteDocumentTreeFile;
export const downloadDocumentSlr = (state: any): DownloadDocumentType =>
	state.fundDetails.documents.fileManager.downloadDocument;

export const getDocumentFolderDetailsSlr = (state: any): GetDocsFolderDetailsType =>
	state.fundDetails.documents.fileManager.getDocumentFolderDetails;

export const updateDOcumentSlr = (state: any): UpdateDocumentType =>
	state.fundDetails.documents.fileManager.updateDocument;
